import AuthLayout from "@container/layout/auth";
import AgentCallSetupContainer from "@container/agent-call-setup";

export default function AgentCallSetupPage() {
    return (
        <AuthLayout>
            <AgentCallSetupContainer />
        </AuthLayout>
    );
}
